export enum ERegions {
  Drop = 'Drop',
  Overview = 'Overview',
  RegionOfInterest = 'RegionOfInterest',
}

export default ERegions;
